import Users from "@js/components/Users";
import { UsersProps } from "@js/components/Users/types";
import HeadComponent from "@js/components/Head";
import { findAllUsers } from "@js/prisma/prisma";

export async function getServerSideProps(context: any) {
    let { search, page } = context.query;
    page = Number(page);
    if (Number.isNaN(page)) {
        page = 0;
    }

    try {
        const { users, numPages } = await findAllUsers(page, search);
        return {
            props: {
                users,
                totalPages: numPages,
            },
        };
    } catch (e) {
        console.error(e);
        return {
            props: {
                users: [],
                totalPages: 1,
            },
        };
    }
}

const UsersPage = (props: UsersProps) => {
    return (
        <>
            <HeadComponent title={"Community"} />
            <Users {...props} />
        </>
    );
};

export default UsersPage;
